var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "workpermit-content-slot__history-split-body workpermit-content-slot__history-split-body--disclosure-grid",
      class: {
        "workpermit-content-slot__history-split-body--disclosure-grid-indicator":
          _vm.disclosureDisabled,
      },
    },
    [
      _c("div", {
        staticClass: "workpermit-content-slot__history-disclosure-grid-bg-col2",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-head-left",
        },
        [
          _c("WpHistoryCommentHeading", {
            attrs: {
              index: _vm.item.index,
              title: _vm.item.title,
              byline: _vm.item.by,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-head-right",
        },
        [
          _c(
            "label",
            {
              staticClass:
                "workpermit-content-slot__show-external-to-contractor",
              class: {
                "workpermit-content-slot__show-external-to-contractor--read-only":
                  _vm.disclosureDisabled,
              },
            },
            [
              _c("input", {
                staticClass: "general-checkbox",
                attrs: { disabled: _vm.disclosureDisabled, type: "checkbox" },
                domProps: { checked: _vm.disclosureChecked },
                on: {
                  change: function ($event) {
                    return _vm.$emit("disclosure-change", $event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "workpermit-content-slot__show-external-to-contractor-text",
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("workPermit.showExternalCommentForContractor")
                    )
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-label-left",
        },
        [
          _c(
            "span",
            { staticClass: "workpermit-content-slot__history-label" },
            [_vm._v(_vm._s(_vm.$t("workPermit.internalCommentsHistoryLabel")))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-label-right",
        },
        [
          _c(
            "span",
            { staticClass: "workpermit-content-slot__history-label" },
            [_vm._v(_vm._s(_vm.$t("workPermit.externalCommentsHistoryLabel")))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-body-left wp-history-internal-comment",
        },
        [
          _c("pre", { staticClass: "workpermit-content-slot__history-pre" }, [
            _vm._v(_vm._s(_vm.internalBody)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "workpermit-content-slot__history-disclosure-grid-body-right wp-history-external-comment",
        },
        [
          _c("pre", { staticClass: "workpermit-content-slot__history-pre" }, [
            _vm._v(_vm._s(_vm.externalBody)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }